import Roles from 'spark-types/Roles';

// SAF-19117 - Added IB Monitor role to the list of all roles
// SAF-20237: Removed temporary IB_CL_SAFETY_RECP role (Role Assignment - Switch Roles and its Precedence - PSR-4763)
// SAF-20491: Added IB_SUPPORT and GAP_PACKET_SUPPORT (split from single Safety Support role)
const { ENTERPRISE_ADMIN, SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_MONITOR, SAFETY_SUPPORT, GAP_PACKET_ADMIN, IB_ADMIN, IB_COUNTRY_LEAD, IB_MONITOR, IB_SUPPORT, GAP_PACKET_SUPPORT } = Roles;

//Enterprise Management
export const em = {
	enterpriseModule: {
		roles: [ ENTERPRISE_ADMIN, SAFETY_ADMIN, SAFETY_SUPPORT, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_MONITOR ]
	},
	manageEnterprises: {
		roles: [ ENTERPRISE_ADMIN ]
	},
	manageUsers: {
		roles: [ ENTERPRISE_ADMIN, SAFETY_ADMIN, SAFETY_SUPPORT ]
	},
	safetyAdmin: {
		roles: [ SAFETY_ADMIN, SAFETY_SUPPORT ]
	}
};

//Safety Management
export const sm = {
	safetyManagementModule: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_MONITOR, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	safetyManagementAndEnterpirses: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_MONITOR, COUNTRY_LEAD, ENTERPRISE_ADMIN, SAFETY_SUPPORT ]
	},
	viewSafetyManagement: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_MONITOR, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	createSafetyLetter: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_SUPPORT ]
	},
	editSafetyLetter: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_SUPPORT ]
	},
	disableSafetyLetter: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_SUPPORT ]
	},
	addSafetyLetterComments: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	toggleCountryDistribution: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	manuallyNotifyRecipients: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	distributionActions: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_SUPPORT ]
	},
	reportTypeConfigurationModule: {
		roles: [ SAFETY_ADMIN, SAFETY_SUPPORT ]
	},
	auditReports: {
		roles: [ SAFETY_ADMIN ]
	},
	overdueAckManagement: {
		roles: [ SAFETY_ADMIN ]
	},
	safetyManagementWithoutCountryLead: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_MONITOR,  SAFETY_SUPPORT ]
	},
	onlyCountryLead: {
		roles: [ COUNTRY_LEAD ]
	},
	manageRoles:{
		roles: [ SAFETY_ADMIN ]
	}
};

//Report Type Configuration
export const rm = {
	reportModule: {
		roles: [ SAFETY_ADMIN, SAFETY_SUPPORT ]
	},
	createReportType: {
		roles: [ SAFETY_ADMIN, SAFETY_SUPPORT ]
	}
};

//Bulk Download Configuration

export const bd = {
	downloadDocuments: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, COUNTRY_LEAD, SAFETY_SUPPORT, SAFETY_MONITOR ]
	}
};

//Manage Gap Packets
// SAF-20491: GAP_PACKET_SUPPORT added alongside GAP_PACKET_ADMIN for GP module permissions
export const gp = {
	createGapPacket: {
		roles: [ GAP_PACKET_ADMIN, GAP_PACKET_SUPPORT ]
	},
	manageGapPacket: {
		roles: [ GAP_PACKET_ADMIN, GAP_PACKET_SUPPORT ]
	}
};
// SAF-17154 Manage IB
// SAF-20491: IB_SUPPORT added alongside IB_ADMIN for IB module permissions
export const ib = {
	createIB: {
		roles: [ IB_ADMIN, IB_SUPPORT ]
	},
	editIB: {
		roles: [ IB_ADMIN, IB_SUPPORT ]
	},
	manageIB: {
		roles: [ IB_ADMIN, IB_SUPPORT, IB_COUNTRY_LEAD, IB_MONITOR ]
	},
	disableIB: {
		roles: [ IB_ADMIN, IB_SUPPORT ]
	},
	distributionActionsIB: {
		roles: [ IB_ADMIN, IB_SUPPORT, IB_COUNTRY_LEAD ]
	},
	manuallyNotifyRecipients: {
		roles: [ IB_ADMIN, IB_SUPPORT, IB_COUNTRY_LEAD ]
	},
	addIBComments: {
		roles: [ IB_ADMIN, IB_SUPPORT, IB_COUNTRY_LEAD ]
	},
	toggleCountryDistribution: {
		roles: [ IB_ADMIN, IB_SUPPORT, IB_COUNTRY_LEAD ]
	},
	ibManagementWithoutCountryLead: {
		roles: [ IB_ADMIN, IB_SUPPORT ]
	},
	onlyCountryLead: {
		roles: [ IB_COUNTRY_LEAD ]
	}
};

// SAF-20491: All support roles included for CTMS refresh visibility
export const ctms = {
	displayCTMSRefreshIndicator: {
		roles: [ SAFETY_ADMIN, SAFETY_MANAGER, SAFETY_MONITOR, COUNTRY_LEAD, SAFETY_SUPPORT, GAP_PACKET_ADMIN, IB_ADMIN, IB_COUNTRY_LEAD, IB_MONITOR, GAP_PACKET_SUPPORT, IB_SUPPORT ]
	}
}